//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import { mapState } from 'vuex'
import { Navbar, TabItem, Indicator } from 'mint-ui'

import axios from 'axios'
const config = window.config
export default {
  name: 'App',
  computed: mapState([
    'user'
  ]),
  data() {
    return {
      loaded: false,
    }
  },
  beforeMount: function() {
    this.getUserByToken()
    console.log(this.$route)
    // dev
  },
  methods: {
    back: function() {
      this.$router.back(-1)
    },
    closeLoad: function () {
      this.loaded = false
      Indicator.close()
    },
    getUserByToken: function () {
      const token = localStorage.getItem('token')
      this.$store.httpDispatch({})('getUserInfo').then((res) => {
        this.closeLoad()
        const { code, data } = res.data
        if (code === 0) {
          this.$store.dispatch('setUser', { user: data.user })
        } else {
          localStorage.clear('token')
          localStorage.clear('tokenExpiredAt')
          this.$router.replace('/phone')
        }
      }).catch((err) => {
        this.closeLoad()
        this.$router.replace('/phone')
        localStorage.clear('token')
        localStorage.clear('tokenExpiredAt')
        console.log(err)
      })
    },
    getQueryVariable: function (variable) {
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
       }
       return(false);
    },
  }
}
